let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("brZLs")).then(() => parcelRequire('31Ui6'));